const WINDOW_LOCATION = {
    SHOW_OUT_OF_STOCK: 'show_out_of_stock',
};

export default WINDOW_LOCATION;
